var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4",staticStyle:{"height":"200vh"}},[_c('iframe',{attrs:{"src":_vm.src,"frameborder":"0","width":"100%","height":"100%","scrolling":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }